module.exports = __webpack_public_path__ + "static/media/1080X1080 HOME-PLATILLOS-CARNES-Y-AVES_50.4dfe7d76.webp";